// extracted by mini-css-extract-plugin
export default {"wrapper":"ShiftActionsModal--wrapper--eb0ca2"};